import { CellContext } from "@tanstack/react-table";
import { useState } from "react";
import { EditAbleCell, StyledTableCellProps } from "./styledTableCell";
import { IdentifiableRow } from "../reactiveTableRenderer";
import SelectField from "../../BaseComponents/select";
import { FieldTypes, FieldStyles, SelectFieldOption_Values } from "../../../Definitions";
import { Value } from "baseui/select";

interface ListOptions {
  options: SelectFieldOption_Values[]
}

export const ListTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn, options, cell}: CellContext<T, string | undefined> & EditAbleCell & ListOptions) => {
  const initialValue = getValue();

  const [value, setValue] = useState(initialValue);

  const onChange = (e: Value) => {
    if (e[0]) {
      const value = String(e[0].label?.valueOf());
      setValue(value)
      if (value !== initialValue) {
        table.options.meta?.updateData(row.original.id, column.id, value);
      }
    }
  }


  return <ListStringCell options={options} staticColumn={staticColumn} key={cell.id} keyPass={cell.id+"Input"} onChange={onChange} canEdit={canEdit} cellData={{value}} />
}


const ListStringCell = ({onChange, canEdit, cellData, keyPass, staticColumn, options}: StyledTableCellProps & EditAbleCell & ListOptions) => {
  if (canEdit) {
    if (staticColumn) { 
      return (
        <div style={{ ...cellData.style, opacity: 0.5  }} key={keyPass}>
          {String(cellData.value) ?? ''}
        </div>
      );
    } else {
      return <SelectField
        options={options}
        defaultValue={cellData.value}
        context={String(cellData.value)}
        overrides={{
          fieldStyle: FieldStyles.greyTertiary,
          fieldType: FieldTypes.editField,
          inTable: true
        }}
        onChange={onChange}
        key={keyPass}
      />;
    }
  }

  return (cellData.value)

}